<template>
  <div
    style="
      font-family: sans-serif;
      font-size: 20px;
      line-height: 1.2;
      padding: 20px;
      margin: 0 auto;
      background-color: white;
      color: black;
      font-weight: bold;
    "
  >
    <!-- Company Header -->
    <div style="text-align: center; margin-bottom: 20px">
      <div style="font-size: 60px; font-weight: bold; margin: 0 0 10px 0; text-align: center">
        <img
          src="@/assets/logo_black.png"
          alt="Scrap Brothers LLC"
          style="width: auto; height: 150px; margin: 10px 0"
        />
        <p style="margin: 10px 0; font-size: 30px">37423 W Highway 16, Bristow, OK 74010</p>
        <p style="margin: 10px 0; font-size: 30px">Phone: (918) 426-9506</p>
      </div>
      <p style="font-size: 36px; font-weight: bold; margin: 20px 0">
        {{ transaction.transaction_type === 'purchase' ? 'PURCHASE RECEIPT' : 'SALES RECEIPT' }}
      </p>
      <div
        style="
          font-size: 20px;
          margin: 25px 0;
          text-align: center;
          border-top: 5px solid #000;
          border-bottom: 5px solid #000;
          padding: 10px 0;
        "
      ></div>
    </div>

    <!-- Transaction Info -->
    <div style="margin-bottom: 20px">
      <div
        style="display: flex; justify-content: space-between; margin-bottom: 10px; font-size: 30px"
      >
        <div style="font-weight: bold">Transaction #:</div>
        <div>{{ transaction.transaction_number }}</div>
      </div>
      <div
        style="display: flex; justify-content: space-between; margin-bottom: 10px; font-size: 30px"
      >
        <div style="font-weight: bold">Date:</div>
        <div>{{ formatDate(transaction.transaction_date) }}</div>
      </div>
      <div
        style="display: flex; justify-content: space-between; margin-bottom: 10px; font-size: 30px"
      >
        <div style="font-weight: bold">Type:</div>
        <div>{{ transaction.transaction_type === 'purchase' ? 'Purchase' : 'Sale' }}</div>
      </div>
      <div
        style="display: flex; justify-content: space-between; margin-bottom: 10px; font-size: 30px"
      >
        <div style="font-weight: bold">Party:</div>
        <div>{{ partyName }}</div>
      </div>
      <div
        style="
          font-size: 20px;
          margin: 25px 0;
          text-align: center;
          border-top: 5px solid #000;
          padding: 10px 0;
        "
      ></div>
    </div>

    <!-- Transaction Items -->
    <div style="margin-bottom: 20px">
      <div style="font-weight: bold; font-size: 36px; margin-bottom: 15px">ITEMS</div>
      <div style="margin-top: 20px">
        <div v-for="(item, index) in items" :key="index" style="margin-bottom: 30px">
          <div style="font-weight: bold; margin-bottom: 10px; font-size: 30px">
            {{ item.commodity_name }}
          </div>
          <div style="padding-left: 20px">
            <div
              style="display: flex; justify-content: space-between; font-size: 25px; margin: 8px 0"
            >
              <span>Gross: {{ item.weight.gross }}</span>
              <span>Tare: {{ item.weight.tare }}</span>
              <span>Net: {{ item.weight.net }}</span>
            </div>
            <div
              style="display: flex; justify-content: space-between; font-size: 25px; margin: 8px 0"
            >
              <span>Price:</span>
              <span>${{ item.price_per_lb }}/lb</span>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                font-size: 25px;
                margin: 8px 0;
                font-weight: bold;
              "
            >
              <span>Total:</span>
              <span>{{ formatCurrency(item.total_price) }}</span>
            </div>
          </div>
          <div style="border-top: 1px dashed #000; margin: 15px 0"></div>
        </div>
      </div>
    </div>

    <!-- Totals -->
    <div style="margin-bottom: 20px; margin-top: 20px">
      <div style="display: flex; justify-content: space-between; margin: 10px 0; font-size: 48px; font-weight: bold">
        <div>Total Weight:</div>
        <div>{{ calculateTotalWeight(props.items) }} lbs</div>
      </div>
      <div style="display: flex; justify-content: space-between; margin: 10px 0; font-size: 48px; font-weight: bold">
        <div>Total Amount:</div>
        <div>{{ formatCurrency(transaction.total_amount) }}</div>
      </div>
      <div
        style="
          font-size: 20px;
          margin: 25px 0;
          text-align: center;
          border-top: 5px solid #000;
          border-bottom: 5px solid #000;
          padding: 10px 0;
        "

      </div>
    </div>

    <!-- Notes Section -->
    <div style="margin-bottom: 0.1in" v-if="transaction.notes">
      <div style="font-weight: bold; font-size: 11px; margin-bottom: 3px; font-family: 'Courier New', monospace">NOTES</div>
      <div style="font-family: 'Courier New', monospace">{{ transaction.notes }}</div>
      <div style="font-size: 10px; margin: 5px 0; text-align: center; font-family: 'Courier New', monospace"></div>
    </div>

    <!-- Footer -->
    <div style="text-align: center; margin-top: 30px; font-size: 30px">
      <p style="margin: 10px 0; font-size: 30px; font-weight: bold">Thank you for your business!</p>

      <!-- Promo Section -->
      <div v-if="includePromos" style="margin-top: 30px; padding: 20px;">
        <div style="font-size: 36px; font-weight: bold; margin-bottom: 15px;">
          ⭐⭐⭐⭐⭐
        </div>
        <div style="font-size: 24px; font-weight: bold; margin-bottom: 10px;">
          Love Your Experience?
        </div>
        <div style="font-size: 20px; margin-bottom: 20px;">
          Leave us a quick Google Review and get<br>
          <span style="font-weight: bold;">+5¢/lb on your next load!</span>
        </div>

        <!-- QR Code with white space -->
        <div style="margin: 20px 0; padding: 20px; background-color: white;">
          <img
            src="@/assets/google_review_qr.png"
            alt="Google Review QR Code"
            style="width: auto; height: 300px; display: block; margin: 0 auto;"
          />
        </div>

        <div style="font-size: 18px; margin-top: 15px;">
          <div style="font-weight: bold; margin-bottom: 5px;">⬆️ Scan this with your phone camera</div>
          <div>Or visit <span style="font-weight: bold;">scrapbros.com/review</span></div>
        </div>
      </div>

      <!-- Simple review request when promos are disabled -->
      <div v-else style="margin-top: 30px; padding: 20px;">
        <div style="font-size: 24px; font-weight: bold; margin-bottom: 10px;">
          Love Your Experience?
        </div>
        <div style="font-size: 20px; margin-bottom: 20px;">
          Leave us a quick Google Review!
        </div>

        <!-- QR Code with white space -->
        <div style="margin: 20px 0; padding: 20px; background-color: white;">
          <img
            src="@/assets/google_review_qr.png"
            alt="Google Review QR Code"
            style="width: auto; height: 300px; display: block; margin: 0 auto;"
          />
        </div>

        <div style="font-size: 18px; margin-top: 15px;">
          <div style="font-weight: bold; margin-bottom: 5px;">⬆️ Scan this with your phone camera</div>
          <div>Or visit <span style="font-weight: bold;">scrapbros.com/review</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { calculateTotalWeight } from '@/utils/transactionHelper'
import { formatDate, formatDateTime, formatCurrency } from '@/utils/formatters'
import { getPaymentMethodLabel, getPaymentStatusLabel } from '@/utils/labels'
import type { TransactionRecord } from '@/types/Transaction'
import type { TransactionItem } from '@/types/Transaction'

const props = withDefaults(
  defineProps<{
    transaction: TransactionRecord
    items: TransactionItem[]
    partyData?: Record<string, unknown>
    partyName?: string
    partyAddress?: string
    partyContact?: string
    includePromos?: boolean
  }>(),
  {
    includePromos: true,
  },
)
</script>
